import React, { useState } from 'react';
import { LinkItem, MenuItem } from '../../models/cms';
import { DropdownIcon } from '../../components/icons';

interface Customprops {
  data: MenuItem[] | undefined;
  closeMainNav: () => void;
  isOpen?: boolean;
}

const Navigation = ({ data, closeMainNav }: Customprops) => {
  const [submenuHeight, setSubmenuHeight] = useState(0);
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <div className="lg:order-first lg:ltr:pr-10 lg:rtl:pl-10">
        {data?.length && (
          <ul className="lg:flex lg:space-x-9">
            {data?.map((item: MenuItem) => {
              return (
                !item?.inactive && (
                  <li key={`menu-${item?.id}`} className="relative group">
                    {item?.subNavItem?.length > 0 ? (
                      <div
                        onMouseEnter={(e) => {
                          if (window.innerWidth > 1024) {
                            const submenu = e.currentTarget.querySelector(
                              '.submenu'
                            );
                            if (submenu) {
                              const height = submenu.scrollHeight;
                              setSubmenuHeight(height + 90);
                            } else {
                              setSubmenuHeight(90);
                            }
                          }
                        }}
                        onMouseLeave={() => {
                          if (window.innerWidth > 1024) {
                            setSubmenuHeight(0);
                          }
                        }}
                        onClick={() => {
                          if (window.innerWidth < 1024) {
                            setExpanded(!expanded);
                          }
                        }}
                      >
                        <div className="relative font-medium flex items-center cursor-pointer py-[7px] lg:py-4 z-[2] text-[34px] lg:text-[15px]">
                          {item?.label}
                          <span className="ltr:pl-3.5 rtl:pr-3.5 lg:ltr:pl-1.5 lg:rtl:pr-1.5 lg:relative lg:-top-0.5">
                            <DropdownIcon />
                          </span>
                        </div>
                        <div
                          className={`submenu lg:absolute text-3xl lg:text-[15px] lg:bottom-0 lg:ltr:left-0 lg:rtl:right-0 z-[2] lg:translate-y-full lg:group-hover:opacity-100 lg:opacity-0 whitespace-nowrap duration-700 ${
                            submenuHeight ? 'lg:delay-300' : ''
                          } ${expanded ? 'is-open' : ''}`}
                          style={{
                            height: submenuHeight
                              ? `${submenuHeight}px`
                              : '0px',
                          }}
                        >
                          <div className="overflow-hidden lg:overflow-visible">
                            <ul className="pb-7 font-light leading-[1.2] lg:pt-1 lg:pb-3">
                              {item?.subNavItem?.map((p: LinkItem) => {
                                return (
                                  !p?.inactive && (
                                    <li key={p?.label}>
                                      <a
                                        href={
                                          `${process.env.REACT_APP_CMS_URL}${p?.url}` ||
                                          ''
                                        }
                                        target="_blank"
                                        className="block py-[7px] lg:py-0.5"
                                        onClick={() => closeMainNav()}
                                      >
                                        {p?.label}
                                      </a>
                                    </li>
                                  )
                                );
                              })}
                            </ul>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <a
                        href={
                          `${process.env.REACT_APP_CMS_URL}${item?.url}` || ''
                        }
                        target="_blank"
                        onClick={() => closeMainNav()}
                        className="block py-[7px] lg:py-4 font-medium cursor-pointer relative z-[2] text-[34px] lg:text-[15px]"
                      >
                        {item?.label}
                      </a>
                    )}
                  </li>
                )
              );
            })}
          </ul>
        )}
      </div>
      <div
        className="bg-white absolute top-0 left-0 w-full transition-all duration-1000 z-[1] pointer-events-none hidden lg:block"
        style={{ height: submenuHeight ? `${submenuHeight}px` : '0px' }}
      />
    </>
  );
};

export default Navigation;
